export default __webpack_public_path__ + "static/Sailec-Regular-ab90882a94147b70a4216b3d76b257bf.woff";